import './Tooltip.scss';
import * as React from 'react';

export interface ITooltip {
  onMouseEnter?: (event: React.MouseEvent<HTMLSpanElement>) => any;
  onMouseLeave?: (event: React.MouseEvent<HTMLSpanElement>) => any;
}

let element: HTMLDivElement;

const getTooltipElement = (): HTMLDivElement => {
  if (!element) {
    element = document.createElement('div');
    element.className = 'CustomTooltip';
    document.body.appendChild(element);
  }

  return element;
}

export const useTooltip = (text?: string | null): ITooltip => {
  if (!text) {
    return {};
  }

  return {
    onMouseEnter: (event) => {
      const target = event.target as HTMLElement;
      if (target.getBoundingClientRect) {
        const tooltip = getTooltipElement();

        tooltip.textContent = text;

        setTimeout(() => {
          tooltip.className = 'CustomTooltip CustomTooltip--visible';
          const rect = target.getBoundingClientRect();
          tooltip.style.left = `${rect.left + rect.width * 0.5}px`;
          tooltip.style.top = `${rect.top - tooltip.getBoundingClientRect().height}px`;
        }, 0);
      }
    },
    onMouseLeave: (event) => {
      if (element) {
        element.className = 'CustomTooltip';
      }
    }
  }
};




// WEBPACK FOOTER //
// ./src/components/CustomTooltip/index.tsx